// BNB
export const DEFAULT_INPUT_CURRENCY = 'LRB'
// BUSD
export const DEFAULT_OUTPUT_CURRENCY = '0xAB7d8fE4eC91E2647Fd1ddEC75CB524FD7c8a603'
